import type { ComponentType } from 'react'
import type { RulesVisual } from '../content'
import ScoringDemo from './ScoringDemo'
import BankerDemo from './BankerDemo'
import ChipsDemo from './ChipsDemo'
import DeadlineDemo from './DeadlineDemo'
import IntuitionDemo from './IntuitionDemo'
import SharpestWeekDemo from './SharpestWeekDemo'
import LeaguesDemo from './LeaguesDemo'
import RivalsDemo from './RivalsDemo'

/** Visual key → demo. Exhaustive by type: a new `RulesVisual` will not compile until it has one. */
export const RULES_DEMOS: Record<RulesVisual, ComponentType> = {
  'scoring-card': ScoringDemo,
  'banker-toggle': BankerDemo,
  'chip-row': ChipsDemo,
  'deadline-clock': DeadlineDemo,
  'intuition-tiers': IntuitionDemo,
  'sharpest-week': SharpestWeekDemo,
  'league-row': LeaguesDemo,
  'rivals-pair': RivalsDemo,
}
